// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonSecurity = {
  normal: "Normal",
  mustChangePassword: "Password change required",
  locked: "Locked",
  unlocked: "Unlocked",
  failedLoginAttempts: "Failed {count} times",
  superuser: "Superuser",
} as const;
